import { render, staticRenderFns } from "./TransportTypeSelect.vue?vue&type=template&id=827dcd18&scoped=true&"
import script from "./TransportTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TransportTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827dcd18",
  null
  
)

export default component.exports